import { Pipe, PipeTransform } from '@angular/core';

/**
 * Status Class Pipe
 *
 * Transforms migration status string into corresponding CSS class name
 *
 * Usage:
 * <span [ngClass]="migration.status | statusClass">{{ migration.status }}</span>
 */
@Pipe({
  name: 'statusClass',
  standalone: false,
})
export class StatusClassPipe implements PipeTransform {
  /**
   * Map of status values to CSS class names
   */
  private readonly statusMap: Record<string, string> = {
    Completed: 'status-completed',
    Inserting: 'status-inserting',
    Failed: 'status-failed',
    'In Progress': 'status-inserting',
    Cancelled: 'status-failed',
    Pending: 'status-pending',
  };

  /**
   * Transform status string to CSS class
   *
   * @param status - Migration status
   * @returns CSS class name
   */
  transform(status: string): string {
    return this.statusMap[status] || 'status-default';
  }
}
